import { render, staticRenderFns } from "./isvps.vue?vue&type=template&id=756eb698&scoped=true&"
import script from "./isvps.vue?vue&type=script&lang=js&"
export * from "./isvps.vue?vue&type=script&lang=js&"
import style0 from "./isvps.vue?vue&type=style&index=0&id=756eb698&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756eb698",
  null
  
)

export default component.exports